import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'inc-general-search',
  templateUrl: './general-search.component.html',
  styleUrls: ['./general-search.component.scss'],
})
export class GeneralSearchComponent {
  @Input() placeholder = 'SEARCH';
  @Input() debounce = 500;
  @Output() callSearch = new EventEmitter<string>();

  constructor() { }

  search(data: any) {
    if (data && data.detail) {
      this.callSearch.emit(data.detail.value);
    }
  }
}
